import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ContactDataIsForm from './ContactDataIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ContactDataIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactDataIs/ContactDataIsForm.container.js